import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Center, Text } from "@chakra-ui/react";
import getReturnRedirectData from "utils/getReturnRedirectData";
import { useSessionCtx, redirectWindowLocation } from "utils";
import EmptyState from "components/EmptyState";
import { FLOW_STATE } from "./PlaidMain";
import { getAllowedRedirectPatterns } from "./allowedRedirectPatternsStorage";

const ErrorViewAndRedirect = ({ error }) => {
  const history = useHistory();
  const { sessionCtx, setFlowState } = useSessionCtx();
  const isMissingAddressError = (error?.data?.codes || []).includes("INVALID_ADDRESS");
  const errorSuffix = isMissingAddressError ? "INVALID_ADDRESS" : encodeURIComponent((error && error.message) || "unknown error");
  const [statusStr] = useState(`${FLOW_STATE.ERROR}.${errorSuffix}`);
  // allowed patterns were signed into the state token and cached in sessionStorage by
  // PlaidMain (SettingsProvider is not populated on this route) - see ./allowedRedirectPatternsStorage
  const [redirectData] = useState(() => getReturnRedirectData(sessionCtx, statusStr, getAllowedRedirectPatterns())); // contains redirect url and wether we should use react router or directly modify browser location
  useEffect(() => {
    if (!redirectData.url) return; // this should only be the case if missing required data to redirect intCtx or flow in sessionCtx
    let timeout = setTimeout(() => {
      if (redirectData.useReactRedirect) {
        // need to handle react router redirect if needed
        setFlowState(statusStr);
        history.push(redirectData.url);
      } else {
        redirectWindowLocation(redirectData.url);
      }
    }, 1000);
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [redirectData, history, setFlowState, statusStr]);
  return (
    <Center data-testid="error-view-and-redirect-wrapper" h="100%" flexDirection="column">
      <EmptyState title="Error" hideButtons={true} error={error} />
      {redirectData.url ? <Text>Redirecting, please wait...</Text> : null}
    </Center>
  );
};

export default ErrorViewAndRedirect;
